import { LifeBuoy, Mail, Phone, Clock } from "lucide-react";
import SupportForm from "../components/SupportForm";
import WhatsAppIcon from "../components/WhatsAppIcon";
import { BRAND } from "../data/brand";

export default function Supporto() {
  return (
    <div data-testid="supporto-page">
      {/* Hero */}
      <section className="bg-slate-50 border-b border-slate-200">
        <div className="container-90 py-20 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
            <div className="lg:col-span-8">
              <div className="overline mb-6">Supporto · Assistenza clienti</div>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.02]">
                Hai bisogno di aiuto?
                <br />
                <span className="text-[color:var(--brand-blue)]">Siamo qui per te.</span>
              </h1>
            </div>
            <div className="lg:col-span-4">
              <p className="text-lg text-slate-600 leading-relaxed">
                Compila il modulo qui sotto per richiedere assistenza, aprire un sinistro,
                modificare un contratto o ricevere informazioni. Ti rispondiamo entro 24 ore
                lavorative.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Form + side info */}
      <section className="section bg-white">
        <div className="container-90">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-8">
              <div className="overline mb-4">Modulo richiesta assistenza</div>
              <h2 className="font-heading text-2xl lg:text-3xl font-extrabold text-slate-900 mb-8 tracking-tight leading-tight">
                Scrivici la tua richiesta.
              </h2>
              <SupportForm />
            </div>

            <aside className="lg:col-span-4 space-y-4">
              <div className="bg-slate-50 border border-slate-200 p-8">
                <LifeBuoy
                  className="w-7 h-7 text-[color:var(--brand-blue)] mb-5"
                  strokeWidth={1.5}
                />
                <h3 className="font-heading text-lg font-bold text-slate-900 mb-3">
                  Risposta rapida
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  Ogni richiesta viene presa in carico da un consulente dedicato. Niente call
                  center, niente passaggi di mano.
                </p>
              </div>

              <a
                href={`tel:${BRAND.phoneRaw}`}
                data-testid="supporto-phone"
                className="block bg-slate-50 border border-slate-200 p-8 hover:border-[color:var(--brand-blue)] hover:bg-white transition-all group"
              >
                <Phone
                  className="w-7 h-7 text-[color:var(--brand-blue)] mb-5"
                  strokeWidth={1.5}
                />
                <div className="overline mb-2">Telefono</div>
                <div className="font-heading text-lg font-bold text-slate-900 group-hover:text-[color:var(--brand-blue)] transition-colors">
                  {BRAND.phone}
                </div>
                <div className="text-xs text-slate-500 mt-3 flex items-start gap-2">
                  <Clock className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                  <span>
                    {BRAND.hours.weekdays}
                    <br />
                    {BRAND.hours.saturday}
                  </span>
                </div>
              </a>

              <a
                href={BRAND.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="supporto-whatsapp"
                className="block bg-[#25D366] p-8 hover:bg-[#1ebe57] transition-all text-white"
              >
                <WhatsAppIcon className="w-7 h-7 mb-5" />
                <div className="overline text-white/80 mb-2">WhatsApp</div>
                <div className="font-heading text-lg font-bold">Scrivici subito</div>
                <div className="text-xs text-white/85 mt-3">
                  Risposta in tempo reale negli orari di apertura
                </div>
              </a>

              <a
                href={`mailto:${BRAND.email}`}
                data-testid="supporto-email"
                className="block bg-slate-50 border border-slate-200 p-8 hover:border-[color:var(--brand-blue)] hover:bg-white transition-all group"
              >
                <Mail
                  className="w-7 h-7 text-[color:var(--brand-blue)] mb-5"
                  strokeWidth={1.5}
                />
                <div className="overline mb-2">Email diretta</div>
                <div className="font-heading text-base font-bold text-slate-900 group-hover:text-[color:var(--brand-blue)] transition-colors break-all">
                  {BRAND.email}
                </div>
              </a>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}
